import {ApiService,Category} from '../libs';
import {DataService} from '../service';

export class OrgService {

  // 获取企业客服列表
  static async getStaffcustomerlist(compId?: number) {
    return await DataService.get(`${ApiService.JrzzApi}/org/staffcustomerlist?compId=${compId}`);
  }

  // 获取联系人
  static getAddressBook(keywords: any) {
    return DataService.get(`${ApiService.JrzzApi}/yun/addressBook/AddressBookList?q=${encodeURIComponent(keywords)}`)
  }

  // 获取本组织所有人员
  static getUsers(queryString: String) {
    return DataService.get(`${ApiService.JrzzApi}/org/stafflist?q=${queryString}&page=1&pageSize=999999`);
  }

  // 获取联系人
  static getContacts(orgId: number) {
    return DataService.get(
        `${ApiService.JrzzApi}/yun/addressBook/AddressBookList?pid=${orgId}`
    );
  }

  // 获取最近联系人
  static getRecentUser() {
    return DataService.get(
        `${ApiService.JrzzApi}/im/GetChatList`
    )
  }

  // 联系人分组
  static getContactGroup() {
    return DataService.get(
        `${ApiService.JrzzApi}/dir/${Category.IMFriendsDir}/list?dirId=0`
    )
  }
}